import {
	getSession200Schema,
	login200Schema,
	loginMutationRequestSchema,
	logout200Schema,
} from "../schemas/authApi.schemas";
import type {
	GetSessionResponse,
	LoginResponse,
	LogoutResponse,
} from "../types/authApi.types";

// API endpoint contracts for authentication management
export const authEndpointContract = {
	login: {
		path: "/auth/login",
		method: "POST" as const,
		requestSchema: loginMutationRequestSchema,
		responseSchema: login200Schema,
		responseType: {} as LoginResponse,
	},
	logout: {
		path: "/auth/logout",
		method: "POST" as const,
		responseSchema: logout200Schema,
		responseType: {} as LogoutResponse,
	},
	getSession: {
		path: "/auth/session",
		method: "GET" as const,
		responseSchema: getSession200Schema,
		responseType: {} as GetSessionResponse,
	},
} as const;
